export const CHECKOUT_DETAILS_TEST_IDS = {
  root: 'checkout-details-page',
  heading: 'heading',
  expiredTag: 'expired-tag',
  paymentSection: 'payment-section',
  cancelledTag: 'cancelled-tag'
};
export const NOTE_TEST_ID = 'note';
export const NOTE_MAX_LENGTH = 255;
